import React, { useState, useContext, useEffect } from 'react';
import { Row, Col, Input, Empty, Switch, Form } from 'antd';
import { ViewDocument } from '../../../../../components';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { Context } from '../../../../../defaults';


const Question2 = ({ data, setData, setDisableNav, current }) => {
    const { dictionary, language } = useContext(Context);

    useEffect(() => {
        if (!(data.studentAnswer.point || data.studentAnswer.point === 0)) {
            setDisableNav(true);
        }
        else {
            setDisableNav(false);
        }
    }, [data.studentAnswer]);

    const onChange = (checked) => {
        setData({ ...data, studentAnswer: { ...data.studentAnswer, isRight: checked ? 1 : 0 } });
    }

    return (
        <div>
            <div key={`answer1${data.question}`} style={{ marginTop: 20 }}>
                <Row gutter={16}>
                    <Col span={20}>

                        {
                            data.studentAnswer.answerVariants && data.studentAnswer.answerVariants.length > 0 &&
                            data.studentAnswer.answerVariants[0].files &&
                            <ViewDocument files={data.studentAnswer.answerVariants[0].files} />
                        }
                        {
                            data.studentAnswer.answerVariants && data.studentAnswer.answerVariants.length > 0 &&
                            data.studentAnswer.answerVariants[0].answerHtml &&
                            <Row gutter={16} style={{ marginBottom: 50 }}>
                                <Col span={24}>
                                    <p style={{ wordWrap: 'break-word' }} dangerouslySetInnerHTML={{ __html: data.studentAnswer.answerVariants[0].answerHtml }} />
                                </Col>
                            </Row>
                        }
                        {

                            (!data.studentAnswer.answerVariants || data.studentAnswer.answerVariants.length === 0 || (
                                (!data.studentAnswer.answerVariants[0].files || data.studentAnswer.answerVariants[0].files.length === 0) && !data.studentAnswer.answerVariants[0].answerHtml))
                            &&
                            <Empty style={{ marginTop: 100 }} description={dictionary?.ThereIsNoStudentsAnswer[language]} />
                        }
                    </Col>
                    <Col span={4}>
                        {/* <div>
                            {dictionary?.AnswerIsRight[language]}
                        </div>
                        <div style={{ marginTop: 30 }}>
                            <Switch
                                checkedChildren={<CheckOutlined />}
                                unCheckedChildren={<CloseOutlined />}
                                checked={data.studentAnswer.isRight === 1}
                                onChange={onChange}
                            />
                        </div> */}
                        <div style={{ marginTop: 30 }}>
                            {dictionary?.Point[language]}
                        </div>
                        <div style={{ marginTop: 30 }}>
                            <Form.Item
                                help={data.studentAnswer.point || data.studentAnswer.point === 0 ? '' : dictionary?.FillTheField[language]}
                                validateStatus={data.studentAnswer.point || data.studentAnswer.point === 0 ? 'success' : 'error'}
                            >
                                <Input type='number' min={0} max={data.studentAnswer.usedHint === 1 ? data.question.hintPoint : data.question.point} value={data.studentAnswer.point} onChange={(e) => {
                                    if (
                                        e.target.value <= (data.studentAnswer.usedHint === 1 ? data.question.hintPoint : data.question.point) &&
                                        e.target.value >= 0
                                    ) {
                                        setData({ ...data, studentAnswer: { ...data.studentAnswer, point: e.target.value } });
                                    }
                                }} />
                            </Form.Item>
                        </div>
                        <div style={{ marginTop: 10 }}>

                            <span style={{ width: '100%', wordWrap: 'break-word', color: '#BEBCBC' }}>{dictionary?.MinPoint[language]}-0, {dictionary?.MaxPoint[language]} - {data.studentAnswer.usedHint === 1 ? data.question.hintPoint : data.question.point}</span>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
}

export default Question2;